import constants from '@src/constants';
import apiMeta from '@src/services/zt/api-meta';

export function buildOverlayMocks(mocks) {
  return Object.keys(mocks || {}).reduce((result, path) => {
    const api = apiMeta.apis[path] || {};
    const title = api.title || path;

    result[path] = {
      title,
      uri: path,
      items: mocks[path].map(mockItem => ({
        ...mockItem,
        apiName: title,
        uri: path
      }))
    };

    return result;
  }, {});
}

/**
 * 拉取 mock 数据并注入 jsonp 拦截
 * 开关收敛到 constants.IS_MOCK_ON（MOCK_ENABLE || __MOCK__，均受非正式环境约束）
 * @return {Promise<*>|Promise<void>}
 */
export default function fetchMock() {
  if (constants.IS_MOCK_ON) {
    const mockModule = require('@src/services/zt/mock');
    return require('./intercept-jsonp-with-mocks').default(buildOverlayMocks(mockModule.default || mockModule));
  }
  return Promise.resolve();
}
